<template>
  <div class="chat-history" :class="{ selected }" @click.stop="switchChat">
    <div class="line1 flex-center-hori">
      <img class="chat-head star star-active" v-if="chat.collected === 1 && !isEditing" src="@/theme/images/icons/icon_star_active.svg" @click.stop="setStar(0)">
      <img class="chat-head star star-inactive" v-else-if="!isEditing" src="@/theme/images/icons/icon_star_inactive.svg" @click.stop="setStar(1)">
      <div v-if="!isEditing" :class="['chat-title',isSearching?'searching':'']"><span>{{ queryArray[0] }}</span><b>{{ queryArray[1] }}</b><span>{{ queryArray[2] }}</span></div>
      <form v-else class="chat-title-edit-form">
        <input type="text" autocomplete="off" v-model="currentText" class="chat-title-edit">
      </form>
      <img v-if="!isEditing && selected" class="chat-operate" src="@/theme/images/icons/icon_export_outline.svg" @click.stop="exportSession(chat.sessionId)">
      <img v-if="isEditing" class="chat-operate large" src="@/theme/images/icons/icon_check_outline.svg" @click.stop="saveEdit">
      <img v-if="isEditing" class="chat-operate large" src="@/theme/images/icons/icon_cross_outline.svg" @click.stop="cancelEdit">
      <img v-if="!isEditing && selected" class="chat-operate hover-show" src="@/theme/images/icons/icon_edit_outline.svg" @click.stop="enterEdit">
      <el-popconfirm width="150" confirm-button-text="删除" cancel-button-text="取消" icon="none" title="删除此会话？" @confirm="deleteChat(chat.sessionId)">
        <template #reference>
          <img v-show="!isEditing && selected" class="chat-operate hover-show" src="@/theme/images/icons/icon_delete_outline.svg">
        </template>
      </el-popconfirm>
    </div>
    <div v-if="chat.knowledgeId" class="line2 flex-center-hori">
        <div class="chat-knowledge">
            知识库：{{chat.knowledgeName}}
        </div>
    </div>
    <div v-if="chat.promptTemplateCode" class="line2 flex-center-hori">
        <div class="chat-knowledge">
            {{promptTemplateSubtitle}}
        </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'ChatHistoryCard',
    props: ['chat', 'query', 'isSearching'],
    data () {
        return {
            isEditing: false,
            currentText: '',
            starActive: false
        };
    },
    methods: {
        switchChat (event) {
            if (event.target.nodeName !== 'DIV') return;
            if (this.selected) return;
            this.isEditing = false;
            this.loadChat(this.chat.sessionId);
        },
        enterEdit () {
            this.currentText = this.chat.title;
            this.isEditing = true;
        },
        saveEdit () {
            this.isEditing = false;
            this.editTitle(this.chat.sessionId, this.currentText);
        },
        cancelEdit () {
            this.isEditing = false;
        },
        setStar (isStar) {
            if (!this.selected) return;
            this.starSession(this.chat.sessionId, isStar);
        }
    },
    computed: {
        modelList () {
            return this.$store.state.appSettings.modelList;
        },
        selected () {
            return this.chat.sessionId === this.currentSessionId();
        },
        queryArray () {
            let title = this.chat.title;
            if (!this.chat.title) return ['未命名聊天', '', ''];
            if (!this.query) return [title, '', ''];
            let startIndex = this.chat.title.indexOf(this.query);
            if (startIndex === -1) return [title, '', ''];
            let result = ['', this.query, ''];
            let endIndex = startIndex + this.query.length;
            result[0] = title.slice(0, startIndex);
            result[2] = title.slice(endIndex);
            return result;
        },
        promptTemplateSubtitle () {
            let model = this.modelList.find(item => item.value === this.chat.modelCode);
            if (!model) return '';
            let promptTemplate = model.promptTemplateList.find(item => item.code === this.chat.promptTemplateCode);
            if (!promptTemplate) return '';
            return model.title + '：' + promptTemplate.name;
        }
    },
    inject: {
        deleteChat: { from: 'deleteChat', default: () => void (0) },
        loadChat: { from: 'loadChat', default: () => void (0) },
        editTitle: { from: 'editTitle', default: () => void (0) },
        starSession: { from: 'starSession', default: () => void (0) },
        exportSession: { from: 'exportSession', default: () => void (0) },
        currentSessionId: { default: '' }
    }
};
</script>
<style scoped lang="scss">
.chat-history {
  position: relative;
  width: 256px;
  margin: 0 16px 8px;
  padding: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  .line1 {
    position: relative;
    width: 100%;
    flex: 1;
  }
  .line2 {
    position: relative;
    width: 100%;
  }
  &.selected {
    // padding-left: 0;
  }

  img {
    flex: 0 0 auto;
  }

  .chat-head {
    width: 16px;
    margin-left: 10px;
    margin-right: 8px;

    &.star {
      cursor: pointer;
      margin-left: 2px;
      margin-right: 2px;
    }
  }

  .star-inactive {
    opacity: 0;
  }

  .chat-title,
  .chat-knowledge,
  .chat-title-edit {
    flex: 1 1 auto;
    font-size: 14px;
    color: rgba($color: #ffffff, $alpha: 0.85);
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 5px;
    b {
      color: rgba(255, 255, 255, 1);
    }
  }
  .searching{
      color: rgba($color: #ffffff, $alpha: 0.65);
  }

  .chat-title {
    pointer-events: none;
  }
  .chat-knowledge {
    pointer-events: none;
    font-size: 12px;
    color: rgba($color: #ffffff, $alpha: 0.65);
    padding-left: 20px;
  }

  .chat-title-edit-form {
    flex: 1 1 auto;
    margin: 0 4px 0 8px;
  }

  .chat-title-edit {
    width: 100%;
    background-color: transparent;
    border: 0 none;
    background-color: rgba(225, 235, 255, 0.15);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 2px;

    &:focus {
      border: 0 none;
      outline: none;
      background-color: rgba(225, 235, 255, 0.2);
    }
  }

  .chat-operate {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    cursor: pointer;
  }

  .chat-operate.large {
    width: 18px;
    margin-right: 8px;
  }

  .chat-operate.hover-show {
    display: none;
  }
}

.chat-history.selected {
  background: var(--menu-history-selected-bg);
  cursor: default;

  .star-inactive {
    opacity: 1;
  }

  .chat-operate.hover-show {
    display: block;
  }
}

.chat-history:hover {
  background-color: rgba($color: #126cff, $alpha: 0.15);

  &.selected {
    background: var(--menu-history-selected-bg);
  }
  .chat-operate.hover-show {
      display: block;
  }
}
</style>
